import React from 'react';
import { useNavigate } from 'react-router-dom';
import { InvestIcon, WithdrawIcon, TeamIcon, ChartIcon } from '../../../assets/icons';
import './QuickActions.css';

const actions = [
  { path: '/invest', icon: InvestIcon, label: 'Invest', color: 'primary' },
  { path: '/withdraw', icon: WithdrawIcon, label: 'Withdraw', color: 'success' },
  { path: '/team', icon: TeamIcon, label: 'Team', color: 'secondary' },
  { path: '/invest?tab=my', icon: ChartIcon, label: 'My Invest', color: 'accent' }
];

const QuickActions = () => {
  const navigate = useNavigate();

  return (
    <div className="quick-actions">
      {actions.map(({ path, icon: Icon, label, color }) => (
        <button
          key={path}
          className={`quick-action quick-action-${color}`}
          onClick={() => navigate(path)}
        >
          <span className="quick-action-icon">
            <Icon size={24} />
          </span>
          <span className="quick-action-label">{label}</span>
        </button>
      ))}
    </div>
  );
};

export default QuickActions;
